import React, { useCallback, useMemo, useState } from 'react';

import { Flags } from './FlagsContext';

export interface FlagsValueContextT {
  flags: Flags;
  setFlags: (flags: Flags) => void;
  areFlagsLoaded: boolean;
}

export const FlagsValueContext = React.createContext<FlagsValueContextT>({
  flags: [],
  setFlags: () => undefined,
  areFlagsLoaded: false,
});

export const FlagsValueProvider = ({ children }: { children: React.ReactNode | React.ReactNode[] }) => {
  const [flagsData, setFlagsData] = useState<Flags>([]);
  const [flagsLoaded, setFlagsLoaded] = useState(false);

  const handleSetFlags = useCallback((flags: Flags) => {
    setFlagsData(flags);
    setFlagsLoaded(true);
  }, []);

  const value: FlagsValueContextT = useMemo(() => {
    return {
      flags: flagsData,
      setFlags: handleSetFlags,
      areFlagsLoaded: flagsLoaded,
    };
  }, [flagsData, handleSetFlags, flagsLoaded]);

  return <FlagsValueContext.Provider value={value}>{children}</FlagsValueContext.Provider>;
};

export const useFeatureFlagsValue = () => {
  const context = React.useContext(FlagsValueContext);

  if (context === undefined) {
    throw new Error('useFlags must be used within a FlagsValueProvider');
  }

  return context;
};
